import React from "react";
import { Link } from "react-router-dom";

export default function CtaBannerBlock({ id, type, kicker, text, title, button, link = "/contact" }) {
  const eyebrow = kicker || text;

  return (
    <div className="container">
      <div className="content-panel p-4 p-lg-5 mt-6 d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-4">
        <div>
          {eyebrow && <p className="section-kicker mb-2">{eyebrow}</p>}
          {title && <h2 className="h3 fw-bold mb-0">{title}</h2>}
        </div>
        {button && (
          <Link to={link} className="btn btn-success">
            {button}
          </Link>
        )}
      </div>
    </div>
  );
}
